import { DownOutlined, UpOutlined } from '@ant-design/icons';
import useDebounce from '@root/core/hooks/useDebounce';
import useTranslate from '@root/core/hooks/useTranslate';
import InquiryServices from '@root/modules/Sellers/Inquiry/services/inquiry';
import { formatDateTime } from '@root/utils/helpers/formatDate';
import { Button, Card, DatePicker, Menu, Table } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import BreadcrumbList from '../../Stock/components/Breadcrumb';
import DropdownButton from '../components/DropdownButton';
import SearchBox from '../components/Search';

interface DataType {
  key: React.Key;
  productName: string;
  sku: number;
  eanUpc: number;
  stockQuantity: number;
  progressStatus: string;
  updated_at: Date;
  setSelectedRow: React.Dispatch<React.SetStateAction<React.Key[]>>;
}

const InquiryPage = () => {
  const [t] = useTranslate();
  const history = useHistory();
  const [listQuotation, setListQuotation] = useState([] as any);
  const [listExcel, setListExcel] = useState([] as any);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItem, setTotaItem] = useState();
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState();
  const [status, setStatus] = useState('');
  const [labelStatus, setLabelStatus] = useState({
    key: '1',
    label: t('seller:button:select')
  } as any);
  const [labelType, setLabelType] = useState({
    key: '2',
    label: t('seller:button:select')
  } as any);
  const [proName, setProName] = useState('');
  const [valueSearch, setValueSearch] = useState('');
  const debounc = useDebounce(valueSearch, 1000);
  const [sort, setSort] = useState(true);
  const [dateValue, setDateValue] = useState<[string, string]>();
  const fromDt: string = (dateValue && dateValue[0]) || '';
  const toDt: string = (dateValue && dateValue[1]) || '';
  const [isSearch, setIsSearch] = useState('');

  const columns: ColumnsType<DataType> = [
    {
      title: 'No',
      dataIndex: 'key'
    },
    {
      title: t('table:seller:product-name'),
      dataIndex: 'productName'
    },

    {
      title: 'SKU',
      dataIndex: 'sku'
    },
    {
      title: 'EAN/UPC',
      dataIndex: 'eanUpc'
    },
    {
      title: '수량',
      dataIndex: 'stockQuantity'
    },
    {
      title: t('table:seller:situation'),
      dataIndex: 'progressStatus'
    },
    {
      title: (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          {t('table:seller:update')}
          {!sort ? (
            <UpOutlined
              style={{ marginLeft: '15px' }}
              onClick={() => setSort(true)}
            />
          ) : (
            <DownOutlined
              style={{ marginLeft: '15px' }}
              onClick={() => {
                setSort(false);
              }}
            />
          )}
        </div>
      ),
      dataIndex: 'updated_at'
    }
  ];
  const Breadcrumb = [
    {
      tittle: '견적 관리',
      url: ''
    },
    {
      tittle: '견적 조회',
      url: ''
    }
  ];
  const getStatus = (e: any) => {
    setStatus(e.key);
    setLabelStatus({ key: e.key, label: e.domEvent.target.innerText });
  };
  const getProductName = (e: any) => {
    setProName(e.key);
    setLabelType({ key: e.key, label: e.domEvent.target.innerText });
  };
  const onChangeState = (name: string, value: string) => {
    setValueSearch(() => {
      return value;
    });
  };
  const getDate = (value: [string, string]) => {
    setDateValue(value);
  };

  const listLabel = [
    {
      id: 1,
      title: '상태',
      labelTitle: t('seller:button:select'),
      listMenu: (
        <Menu
          onClick={getStatus}
          items={[
            {
              label: t('seller:dropdown:request'),
              key: 'new'
            },
            {
              type: 'divider'
            },
            {
              label: '승인',
              key: 'accepted'
            }
          ]}
        />
      )
    },
    {
      id: 2,
      labelTitle: t('seller:button:select'),
      listMenu: (
        <Menu
          onClick={getProductName}
          items={[
            {
              label: t('table:seller:product-name'),
              key: 'productName'
            },
            {
              type: 'divider'
            },
            {
              label: 'SKU',
              key: 'sku'
            },
            {
              type: 'divider'
            },
            {
              label: 'UPC',
              key: 'upc'
            }
          ]}
        />
      )
    }
  ];

  const rowSelection = {
    onChange: (selectedRowKeys: React.Key[], selectedRows: DataType[]) => {
      setListExcel(selectedRows);
    },
    getCheckboxProps: (record: DataType) => ({
      disabled: record.productName === 'Disabled User', // Column configuration not to be checked
      name: record.productName
    })
  };

  const { RangePicker } = DatePicker;
  const dateFormat = 'YYYY/MM/DD';
  const idExport = listExcel.map((item: any) => ({
    key: item.key
  }));

  const handelExportExcel = async (
    fieldSearch: string,
    productName: string,
    sort: boolean,
    fromDt: string,
    toDt: string,
    status: string
  ) => {
    if (listExcel.length > 0) {
      const responseById = await InquiryServices.exportExcelById(idExport);
      const outputFilename = `Inquiry_240406T9g6QGJSxyR.xlsx`;
      const url = URL.createObjectURL(new Blob([responseById]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', outputFilename);
      document.body.appendChild(link);
      link.click();
    } else {
      const response = await InquiryServices.exportExcel({
        fieldSearch,
        productName,
        sort,
        fromDt,
        toDt,
        status
      });
      const outputFilename = `Inquiry_240406T9g6QGJSxyR.xlsx`;
      const url = URL.createObjectURL(new Blob([response]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', outputFilename);
      document.body.appendChild(link);
      link.click();
    }
  };

  const getPagination = async (
    page: any,
    status: any,
    fieldSearch: any,
    productName: any,
    sort: boolean,
    fromDt: string,
    toDt: string
  ) => {
    setLoading(true);
    const temp = await InquiryServices.getPaging({
      page,
      status,
      fieldSearch,
      productName,
      sort,
      fromDt,
      toDt
    });

    let list: any[] = [];
    temp.data.forEach((element: any) => {
      return element.products.forEach((item: any, index: number) => {
        if (index !== 0) {
          return;
        }
        list.push({
          key: element.id,
          progressStatus: element.progressStatus,
          sku: item.sku,
          eanUpc: item.eanUpc,
          stockQuantity: item.estimateQuantity,
          updated_at: formatDateTime(element.updated_at),
          // updated_at: moment(element.updated_at)
          //   .utc()
          //   .format('YYYY-MM-DD hh:mm:ss A'),
          productName: item.productName,
          updateAtSort: item.updated_at,
          warehouseName: element.warehouse.name
        });
      });
    });

    setListQuotation(list);
    setTotalPages(temp.meta.totalPages);
    setCurrentPage(temp.meta.currentPage);
    setLimit(temp.meta.itemsPerPage);
    setTotaItem(temp.meta.totalItems);
    setLoading(false);
  };
  useEffect(() => {
    if (!!valueSearch && !!proName) setIsSearch(valueSearch);
    else if (!!isSearch && !valueSearch) {
      setIsSearch('');
    }
  }, [debounc, proName]);

  useEffect(() => {
    getPagination(1, status, proName, valueSearch, sort, fromDt, toDt);
  }, [status, isSearch, sort, fromDt, toDt]);

  return (
    <div>
      <BreadcrumbList listBreadcrumb={Breadcrumb} />
      <div className="admin-container">
        <Card
          bordered={false}
          className="admin-card"
          style={{
            minHeight: '80vh',
            background: 'none'
          }}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          ></div>
          <div className="control">
            <RangePicker
              onChange={(date: any, dateString: [string, string]) => {
                getDate(dateString);
              }}
              placeholder={['YYYY.MM.DD', 'YYYY.MM.DD']}
              format={dateFormat}
            />
            {listLabel.map((item) => {
              return (
                <DropdownButton
                  key={item.id}
                  title={item.title}
                  label={item.id === 1 ? labelStatus.label : labelType.label}
                  menu={item.listMenu}
                />
              );
            })}
            <SearchBox
              type
              onChange={(e: any) =>
                onChangeState('Value Search', e.target.value)
              }
            />
          </div>
          <div className="table">
            <div>
              <div
                style={{
                  marginBottom: 16,
                  display: 'flex',
                  justifyContent: 'space-between',
                  paddingTop: 16
                }}
              >
                <div className="table__head">
                  <span style={{ marginLeft: 8 }}>
                    {t('warehouse:inquiry:total-inquiry')} {totalItem}
                  </span>
                  <span className="table__head --right">
                    {t('warehouse:inquiry:select-inquiry')}
                    {listExcel.length}
                  </span>
                </div>

                <div>
                  <Button
                    className="downExcel"
                    onClick={() => {
                      handelExportExcel(
                        valueSearch,
                        proName,
                        sort,
                        fromDt,
                        toDt,
                        status
                      );
                    }}
                  >
                    {t('common:download')}
                  </Button>
                </div>
              </div>
              <Table
                loading={loading}
                columns={columns}
                dataSource={listQuotation}
                rowSelection={rowSelection}
                pagination={{
                  total: totalPages * 10,
                  current: currentPage,
                  showSizeChanger: false,
                  onChange: (page, limit) => {
                    getPagination(
                      page,
                      status,
                      proName,
                      valueSearch,
                      sort,
                      fromDt,
                      toDt
                    );
                  }
                }}
                onRow={(item) => {
                  return {
                    onClick: () => {
                      history.push(`/admin/seller/quote/${item.key}`);
                    }
                  };
                }}
              />
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default InquiryPage;
